import React from 'react';
import type { CompatReportDocument } from '../types';

interface TurningViewProps {
  result: CompatReportDocument;
}

export const TurningView: React.FC<TurningViewProps> = ({ result }) => {
  const f = result.flipping;
  if (!f) {
    return (
      <div className="rounded-xl border border-[#E2E5EA] bg-white p-5 text-[14px] text-heritage-grey">
        No flipping comparison in this report.
      </div>
    );
  }

  // Sample-ui: when turning is off, show only the statement — no with/without comparison.
  if (!f.allowed) {
    return (
      <div className="rounded-xl border border-[#E2E5EA] bg-white p-5 relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-hero-red" />
        <p className="text-[11px] font-semibold tracking-wider uppercase text-heritage-grey mb-3">
          Turning pipes
        </p>
        <div className="border-l-[3px] border-blueprint-blue bg-[rgba(0,39,63,0.05)] rounded-r-lg px-4 py-3 text-[13.5px] text-text-grey">
          <span className="font-semibold text-blueprint-blue">
            {f.statement ||
              'Turning pipes end-for-end is not allowed on this run. Every number in this report is without turning.'}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-[#E2E5EA] bg-white p-5 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-hero-red" />
      <p className="text-[11px] font-semibold tracking-wider uppercase text-heritage-grey mb-3">
        Is turning pipes end-for-end worth it?
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="rounded-xl border border-[#E2E5EA] bg-white p-4 relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-galvanizing-green" />
          <p className="text-[11px] font-semibold tracking-wider uppercase text-heritage-grey">
            Turning allowed
          </p>
          <div className="font-heading font-bold text-blueprint-blue text-[clamp(2rem,6vw,3.5rem)] leading-none mt-1">
            {Math.round(f.withTurning)}
            <span className="text-[18px] text-heritage-grey font-semibold ml-1.5">
              of {f.pipesTotal}
            </span>
          </div>
        </div>
        <div className="rounded-xl border border-[#E2E5EA] bg-white p-4 relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#E6A100]" />
          <p className="text-[11px] font-semibold tracking-wider uppercase text-heritage-grey">
            Turning off
          </p>
          <div className="font-heading font-bold text-blueprint-blue text-[clamp(2rem,6vw,3.5rem)] leading-none mt-1">
            {Math.round(f.withoutTurning)}
            <span className="text-[18px] text-heritage-grey font-semibold ml-1.5">
              of {f.pipesTotal}
            </span>
          </div>
        </div>
      </div>
      {f.statement && (
        <div className="mt-4 border-l-[3px] border-blueprint-blue bg-[rgba(0,39,63,0.05)] rounded-r-lg px-4 py-3 text-[13.5px] text-text-grey">
          <span className="font-semibold text-blueprint-blue">{f.statement}</span>
        </div>
      )}
    </div>
  );
};
